export default [{
  path: '/simulacoes-laudos-express',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Simulacoes Laudos Express Historico',
      path: 'historico',
      component: () => import('@/views/simulacoesLaudosIncrementais/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Simulacoes de Laudos Express' }
        ]
      }
    },
    {
      name: 'Simulacoes Laudos Express Editar',
      path: 'edit/:id',
      component: () => import('@/views/simulacoesLaudosIncrementais/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Simulacoes de Laudos Express', path: '/simulacoes-laudos-express/historico' },
          { name: 'Editar' }
        ]
      }
    },
    {
      name: 'Simulacoes Laudos Express Add',
      path: 'edit',
      component: () => import('@/views/simulacoesLaudosIncrementais/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Simulacoes de Laudos Express', path: '/simulacoes-laudos-express/historico' },
          { name: 'Adicionar' }
        ]
      }
    }
  ]
}]